<template>
  <main-layout>
    <v-content>
      <v-container>
        <v-row>
          <v-col cols="12">
            <clients-table :isCreating.sync="isCreating" :key="key" />
            <v-dialog v-model="isCreating" width="800px">
              <v-card>
                <v-card-title class="primary white--text d-flex justify-space-between">
                  <span>Register A new Client</span>
                  <v-btn text icon dark @click="isCreating = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-container>
                  <create-client-form @created="onCreated" />
                </v-container>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </main-layout>
</template>
<script>
import ClientsTable from './clientsTable';
import CreateClientForm from './createClientForm';

export default {
  components: { ClientsTable, CreateClientForm },
  data() {
    return {
      isCreating: false,
      key: 0,
    };
  },
  methods: {
    onCreated() {
      this.isCreating = false;
      ++this.key; // change the key so that vue can re-render the component
      Notify.success('Client was created successfully');
    },
  },
};
</script>
